import { render } from "./SoapManager.vue?vue&type=template&id=33d5e2b0"
import script from "./SoapManager.vue?vue&type=script&lang=js"
export * from "./SoapManager.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__